export { Text } from './Text.js';
//# sourceMappingURL=index.js.map
